import { createSelector } from "@reduxjs/toolkit";
import Guid from "_shared/guids/guid";
import { userNetworkInvitationApi } from "users/networking/connections/invitations/_api/network-invitation-api";
import NetworkInvitationQuery from "users/networking/connections/invitations/_api/queries/network-invitation-query";
import NetworkInvitationInfo from "users/networking/connections/invitations/network-invitation-info";
  
const invitationQuery = new NetworkInvitationQuery({});

export const selectNetworkInvitationByUserId = (userId?: Guid) =>
  createSelector(
    [userNetworkInvitationApi.endpoints.getUserNetworkInvitations.select(invitationQuery)],
    (result) => {
      if (!userId) return undefined;
      const invitationJson = result.data?.data.find((invitation) => invitation.id === userId.value);
      if (!invitationJson) return undefined;
      return NetworkInvitationInfo.fromJSON(invitationJson);
    }
  );
